import { requestPapi } from '@paradigm/api/src/fetch-api';

export async function updateFirmLeaderboardAnonymity(isPublic: boolean) {
  const resp = await requestPapi({
    body: { disabled_leaderboard_anonymity: isPublic },
    url: '/v1/leaderboard/preferences/',
    method: 'PUT',
  });

  return resp;
}
